import CommonTablePage, { CommonTablePagePropsInterface } from '../../../../../components/common/common-table/common-table-page'
import React, { useRef, useState,useEffect } from 'react'
import WorkOrderManagementColumnModel from './work-order-management-column-model'
import { urlKey } from '../../../../../services/api/api-urls'
import WorkOrderAddDialog from './work-order-add-dialog/work-order-add-dialog'
import CommonDialog from '../../../../../components/common/others/common-dialog'
import { ApiRequest } from '../../../../../services/api/api'
import SweetAlertService from '../../../../../services/lib/utils/sweet-alert-service'
import { getRandomKey, nsStr } from '../../../../../services/lib/utils/helpers'
import SuborderCommonMachineList from '../../operator/suborder-list/suborder-common-machine-list'
import { useDocumentTitle } from '../../../../../services/title/useDocumentTitle'
import { Button } from 'antd'

const refreshTime=5;
const WorkOrderManagementPage = (props: {stockMonitorProductId?: any}) => {
  const [triggerResetData, setTriggerResetData] = useState<any>(false)
  const [isShowSpinner, setIsShowSpinner] = useState(true)
  const [open, setOpen] = useState(false)
  // 批量操作：勾选的工单行
  const [selectedRows, setSelectedRows] = useState<any[]>([])
  const [dialogTitle, setDialogTitle] = useState<string>()
  const [selectedMachine, setSelectedMachine] = useState<any>()
  const [footer, setFooter] = useState<any>()
  const [handleMachinesShown, setHandleMachinesShown] = useState<boolean>(false)

  const [value, setValue] = useState<number>(refreshTime);
  const [timers, setTimers] = useState<Array<NodeJS.Timeout>>([]);
  const saveCallBack: any = useRef();

  const callBack = () => {
    if (open ) {
      setValue(5);
      return
    } 
    if (value <= 1) {
      setTriggerResetData(getRandomKey())
      setValue(5);
      return
    }
    setValue(value - 1);
  };

  useEffect(() => {
    saveCallBack.current = callBack;
    return () => { };
  });
  useDocumentTitle();

   useEffect(() => {
    // document.title = "Work Order";
    const tick = () => {
      saveCallBack.current();
    };
    const timer: NodeJS.Timeout = setInterval(tick, 60000);
    timers.push(timer);
    setTimers(timers);
    console.log(timers);
    return () => {
      clearInterval(timer);
    };
  }, []);

  const onDialogClose = (isModified: boolean) => {
    setIsShowSpinner(false)
    setOpen(false)
    if (isModified) {
      setTriggerResetData(getRandomKey())
    }
  }

  const updateApproveStatus = async (rowData: any) => {
    const result = await SweetAlertService.inputConfirm({type: 'textarea', title: 'WorkOrder Approve', placeholder: 'Comment', defaultValue: rowData.comments, handleRequired: true})
    if (result !== undefined) {
      ApiRequest({
        url: 'WorkOrder/ApproveWorkOrder?id=' + rowData.workOrderId + '&approvedComment=' + result,
        method: 'put'
      }).then(_ => {
        setTriggerResetData(getRandomKey())
      })
    }
  }

  // change work order status comments, using new put api request
  const updateStatusComments = async (rowData: any) => {
    const result = await SweetAlertService.inputConfirm({type: 'textarea', title: 'Change Comments', placeholder: 'Comment', defaultValue: rowData.comments})
    if (result ) {
      ApiRequest({
        url: 'WorkOrder/WorkOrderComments?id=' + rowData.workOrderId + '&comments=' + result,
        method: 'put'
      }).then(_ => {
        setTriggerResetData(getRandomKey())
      })
    }
  }

  const updateQuantity = async (rowData: any) => {
    const result = await SweetAlertService.inputConfirm({type: 'number', title: 'Update Quantity', placeholder: 'qty'})
    if (result !== null) {
      if (!result) {
        await SweetAlertService.errorMessage('Please type in quantity before submitting')
        return
      } else {
        console.log(result)
        ApiRequest({
          url: 'WorkOrder/UpdateWorkOrderQuantity?id=' + rowData.workOrderId + '&quantity=' + parseInt(result),
          method: 'put'
        }).then(_ => {
          setTriggerResetData(getRandomKey())
        })
      }
    }
  }

  const updateUrgent = async (rowData: any) => {
    ApiRequest({
      url: 'WorkOrder/WorkOrderUrgent?id=' + rowData.workOrderId + '&urgent=' + !rowData.urgent,
      method: 'put'
    }).then(_ => {
      setTriggerResetData(getRandomKey())
    })
  }

  // ==================== 批量操作 ====================
  // 仅针对等待批准（workOrderStatusId === -1）的工单；选中行中不符合条件的会被跳过并在提示中说明
  const getPendingFromSelection = () => {
    if (!selectedRows.length) {
      SweetAlertService.errorMessage('Please select work orders first.')
      return null
    }
    const pending = selectedRows.filter((row: any) => row.workOrderStatusId === -1)
    if (!pending.length) {
      SweetAlertService.errorMessage('Only work orders awaiting approval (New) can be batch operated.')
      return null
    }
    return pending
  }

  // 批量批准：approvedComment 继承每张工单的 note to production（即现有 comments）
  const batchApprove = async () => {
    const pending = getPendingFromSelection()
    if (!pending) return
    const skipped = selectedRows.length - pending.length
    const result = await SweetAlertService.confirmMessage(
      `Approve ${pending.length} work order(s)?` +
      (skipped ? ` (${skipped} selected order(s) not awaiting approval will be skipped.)` : '') +
      ' The approved comment will inherit each order\'s note to production (existing comments).'
    )
    if (!result) return

    let success = 0
    let failed = 0
    await Promise.allSettled(pending.map((row: any) =>
      ApiRequest({
        url: 'WorkOrder/ApproveWorkOrder?id=' + row.workOrderId + '&approvedComment=' + encodeURIComponent(row.comments || ''),
        method: 'put'
      }).then(() => { success++ }).catch(() => { failed++ })
    ))
    if (failed) {
      SweetAlertService.errorMessage(`Approved ${success} work order(s), failed ${failed}.`)
    } else {
      SweetAlertService.successMessage(`${success} work order(s) approved.`)
    }
    setSelectedRows([])
    setTriggerResetData(getRandomKey())
  }

  const batchDelete = async () => {
    const pending = getPendingFromSelection()
    if (!pending) return
    const skipped = selectedRows.length - pending.length
    const result = await SweetAlertService.confirmMessage(
      `Delete ${pending.length} work order(s)? This action cannot be undone.` +
      (skipped ? ` (${skipped} selected order(s) not awaiting approval will be skipped.)` : '')
    )
    if (!result) return

    let success = 0
    let failed = 0
    await Promise.allSettled(pending.map((row: any) =>
      ApiRequest({
        url: 'WorkOrder/DeleteWorkOrder?id=' + row.workOrderId,
        method: 'delete'
      }).then(() => { success++ }).catch(() => { failed++ })
    ))
    if (failed) {
      SweetAlertService.errorMessage(`Deleted ${success} work order(s), failed ${failed}.`)
    } else {
      SweetAlertService.successMessage(`${success} work order(s) deleted.`)
    }
    setSelectedRows([])
    setTriggerResetData(getRandomKey())
  }

  const workOrderProductManagementDialog = <WorkOrderAddDialog onDialogClose={onDialogClose} />

  const actionButtons: any = [
    {
      icon: 'ghost', //Button attr of Ant design (danger, ghost)
      tooltip: 'New WorkOrder',
      isFreeAction: true,
      onClick: (event: any, rowData: any) => {
        setOpen(true)
        setDialogTitle('New WorkOrder')
      }
    },
    {
      icon: 'ghost', //Button attr of Ant design (danger, ghost)
      tooltip: 'Show Machines',
      isFreeAction: true,
      onClick: (event: any, rowData: any) => {
        setHandleMachinesShown(!handleMachinesShown)
      }
    }
  ]
  const onFilterChange = (tableRef: any) => {
    // setFooterInfo(tableRef.current.dataManager.searchedData)
    // debounce(setFooterInfo(tableRef.current.dataManager.searchedData),100000)
    debounce(() => setFooterInfo(tableRef.current.dataManager.searchedData),3000)
  }
  let timer:any;
  const debounce = (func:any, timeout = 1000) =>{
    console.log("debouse")
    if (timer) clearTimeout(timer) 
    timer = setTimeout(() => { func(); }, timeout);
  }  

  const setFooterInfo =  (tableRef: any) => {
    console.log("setFooterInfo")
    let total_qty = 0 ,appr_jobs=0,appr_qty=0;
    tableRef.map((e:any)=>{
      total_qty = total_qty + e.quantity
      if (e.workOrderStatusId>=1){
        appr_jobs = appr_jobs+1;
        appr_qty = appr_qty+e.quantity
      }
    })
    setFooter({
      jobs:tableRef.length,
      total_qty: total_qty,
      appr_jobs:appr_jobs,
      appr_qty:appr_qty,
      })
  }
  const getRenderData = async (data: any) => {
    let res = await ApiRequest({
      url: 'Product/GetAllProductName',
      method: 'get'
    })
    const products = res.data.data;
    const findProductById = (id:number) =>{
      const product = products.find((product:any) => product.productId === id);
      if (product) {
        return product;
      } else {
        return null; // 或者根据需求返回其他值，如 { error: 'Product not found' }
      }
    }    
    // debugger
    // console.log(data)
    const renderData: any = []
    data.map((row: any) => {
      if (row.workOrderStatusId !== 0) {
        const productCode = findProductById(row.productId)?.productCode;
        const productName = findProductById(row.productId)?.productName;
        row.product = findProductById(row.productId);
        const newData = {
          ...row,
          actionId: row.actionDto?.actionId,
          routingTypeName: row.routingDto?.productTypeName,
          urgent: row.urgent ? 1 : 0,
          productCode: productCode,
          productFilter: productName + nsStr(productName),// + ' ' + row.product?.description,
          createdEmployeeName: (row.createdEmployee?.firstName || '') + ' ' + (row.createdEmployee?.lastName || ''),
          createdAt1: row.createdAt,
          requiredDate1: row.requiredDate,
          createdAt: row.createdAt && (new Date(row.createdAt + '.000Z')).toLocaleString(),
          requiredDate: row.requiredDate && (new Date(row.requiredDate + '.000Z')).toLocaleDateString(),
          workOrderNo: row.workOrderNo && parseInt(row.workOrderNo),
          workOrderStatusId1: row.workOrderStatusId==2?1:row.workOrderStatusId
        }
        if (props.stockMonitorProductId) {
          if (row.productId === props.stockMonitorProductId) {
            renderData.push(newData)
          }
        } else {
          renderData.push(newData)
        }
      }
    })
    // console.log(renderData)
    // 应用 defaultFilter (Status 字段默认过滤 ['-1', '1', '2'])
    // 初始加载时应该使用过滤后的数据计算 footer
    const defaultFilteredData = renderData.filter((row: any) => {
      // Status 字段的 defaultFilter: ['-1', '1', '2']
      const statusId = row.workOrderStatusId1?.toString();
      return ['-1', '1', '2'].includes(statusId);
    });    
    setFooterInfo(defaultFilteredData);    
    return renderData
  }

  const getUpdateData = (dataDetail: any) => {
    if ([10, 0].includes(dataDetail.workOrderStatusId)) {
      SweetAlertService.errorMessage('This order is cancelled or completed, so not deletable.')
      return ''
    }
    return dataDetail
  }

  const commonTablePageProps: CommonTablePagePropsInterface = {
    urlInfoKey: urlKey.WorkOrder,
    getAllUrl: selectedMachine?.machineId ? `/WorkOrder/GetWorkOrderByMachineId?machineId=${selectedMachine.machineId}` : `/WorkOrder/GetAllWorkOrder`,
    title: 'Work Order',
    column: WorkOrderManagementColumnModel({
      updateApproveStatus: updateApproveStatus,
      updateStatusComments: updateStatusComments,
      updateQuantity: updateQuantity,
      updateUrgent: updateUrgent,
    }),
    mappingRenderData: (data: any) => getRenderData(data),
    mappingUpdateData: (dataDetail: any) => getUpdateData(dataDetail),
    triggerResetData: triggerResetData,
    onFilterChange: onFilterChange,    
    actionButtons: props.stockMonitorProductId ? [] : actionButtons,
    isNotDeletable: props.stockMonitorProductId,
    isNotEditable: true,
    isNotAddable: true,
    // 启用多选框（仅工单管理页，stock-monitor 嵌入页不启用），供批量批准/删除使用
    isEnableSelect: !props.stockMonitorProductId,
    onSelectionChange: (rows: any[]) => setSelectedRows(rows || []),
    isShowSpinnerOnInit: isShowSpinner
  }

  return (
    <div>
      {/* 添加表格行悬停样式 - 支持 Material-UI 和 Ant Design */}
      <style>{`
        /* Material-UI 表格悬停效果 */
        .MuiTableRow-root:hover {
          background-color: rgba(0, 0, 0, 0.08) !important;
        }
        .MuiTableRow-root {
          transition: background-color 0.2s ease;
        }
        
        /* Ant Design 表格悬停效果 */
        .ant-table-tbody > tr:hover > td {
          background-color: rgba(0, 0, 0, 0.08) !important;
        }
        .ant-table-tbody > tr {
          transition: background-color 0.2s ease;
        }
      `}</style>
      
      { value<refreshTime &&<div style={{position:'fixed',marginTop:"0px",right:"400px",zIndex:999,border:"solid 1px",padding:"10px",color:"red"}}>Refresh in {value} minutes!</div>}                  
      <div style={{display: handleMachinesShown ? 'block' : 'none'}}>
        <SuborderCommonMachineList selectMachine={(data: any) => {
          console.log(data)
          setSelectedMachine(data)
          setTriggerResetData(getRandomKey())}} areAll={true}/>
        <div style={{ marginBottom: '2rem' }}>&nbsp;</div>
      </div>
      {/* 批量操作栏：勾选工单后才出现；清除勾选（含操作完成刷新）后自动消失 */}
      {!props.stockMonitorProductId && selectedRows.length > 0 && (
        <div style={{
          marginBottom: '8px',
          padding: '6px 12px',
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          backgroundColor: '#f8fafc',
          border: '1px solid #e2e8f0',
          borderRadius: '6px',
        }}>
          <span style={{ fontWeight: 500 }}>
            Selected: {selectedRows.length}
          </span>
          <Button
            type="primary"
            size="small"
            style={{
              backgroundColor: '#f97316',
              borderColor: '#f97316',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: 26,
              padding: '0 10px',
              lineHeight: 1,
            }}
            onClick={batchApprove}
          >
            Batch Approve
          </Button>
          <Button
            type="primary"
            size="small"
            danger
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: 26,
              padding: '0 10px',
              lineHeight: 1,
            }}
            onClick={batchDelete}
          >
            Batch Delete
          </Button>
        </div>
      )}
      <div style={{ whiteSpace: 'pre-line' }}>
        <CommonTablePage {...commonTablePageProps} />
      </div>
      <CommonDialog title={dialogTitle} open={open} onDialogClose={onDialogClose} dialogContent={workOrderProductManagementDialog} />
      <div style={{marginTop:"10px",marginLeft:"40px"}}>
        <span><b>Total Jobs:&nbsp;</b>{footer?.jobs}&nbsp;&nbsp;</span>
        <span><b>Total Qty:&nbsp;</b> {footer?.total_qty}&nbsp;&nbsp;</span>
        <span><b>Approved Jobs:&nbsp;</b>{footer?.appr_jobs}&nbsp;&nbsp;</span>
        <span><b>Approved Qty:&nbsp;</b> {footer?.appr_qty}&nbsp;&nbsp;</span>        
      </div>
    </div>
  )
}

export default WorkOrderManagementPage
